// auth.js
export const LOGOUT = 'LOGOUT'
export const UPDATE_LOGIN = 'UPDATE_LOGIN'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const SAVE_LEGACY_TOKEN = 'SAVE_LEGACY_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'

export const UPDATE_RESET_PASSWORD = 'UPDATE_RESET_PASSWORD'

export const UPDATE_USER = 'UPDATE_USER'

export const UPDATE_DATA_DATE_RANGE = 'UPDATE_DATA_DATE_RANGE'

export const UPDATE_REGISTER_ADVERTISER_FORM = 'UPDATE_REGISTER_ADVERTISER_FORM'
export const UPDATE_REGISTER_ADVERTISER = 'UPDATE_REGISTER_ADVERTISER'

export const UPDATE_EDIT_SHOP_STATE = 'UPDATE_EDIT_SHOP_STATE'
export const SET_SHOP = 'SET_SHOP'
export const UPDATE_SHOP_ATTRIBUTE = 'UPDATE_SHOP_ATTRIBUTE'
export const UPDATE_STRIPE = 'UPDATE_STRIPE'

export const SET_USER_TAGS = 'SET_USER_TAGS'
export const UPDATE_USER_TAG = 'UPDATE_USER_TAG'
export const SET_USER_TAGS_LOADING = 'SET_USER_TAGS_LOADING'
export const SET_SAVING_USER_TAG = 'SET_SAVING_USER_TAG'
export const UPDATE_USER_TAGS_ID = 'UPDATE_USER_TAGS_ID'

export const SET_ECHO_ACTIVATED = 'SET_ECHO_ACTIVATED'

export const SET_POPUP = 'SET_POPUP'
export const SET_ERROR = 'SET_ERROR'
export const SET_LOADING = 'SET_LOADING'
export const SET_FETCHING = 'SET_FETCHING'
export const SET_IS_FETCHED = 'SET_IS_FETCHED'
export const SET_DATA = 'SET_DATA'
export const RESET = 'RESET'
